module.exports = __webpack_public_path__ + "770508f72855ff8f91ae68def35fcdbf.glb";